import script from "./NhapKhoVatTuPhuTungPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapKhoVatTuPhuTungPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./NhapKhoVatTuPhuTungPrintModal.vue?vue&type=style&index=0&id=b0690832&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0690832"]])

export default __exports__